import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";

function Header({ setPage }) {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [open, setOpen] = useState(null); // control de submenús
    const ref = useRef(null);

    const handleScroll = () => setScrolled(window.scrollY > 50);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);

    const toggleSub = (key) => setOpen((prev) => (prev === key ? null : key));

    useEffect(() => {
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(null);
        };
        const onKey = (e) => e.key === "Escape" && setOpen(null);
        document.addEventListener("mousedown", onDocClick);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDocClick);
            document.removeEventListener("keydown", onKey);
        };
    }, []);

    return (
        <header className="header">
            {/* Logo + Título */}
            <div className="logo">
                <Link to="/" smooth="true" duration={500} offset={-30}>
                    <img
                        src="logos/logo_fbmclm.webp"
                        alt="Logo"
                        className="logo-image"
                    />
                </Link>
                <div className="titulo-container-header">
                    <h1 className="texto-titulo-header">
                        FEDERACIÓN DE BALONMANO DE CASTILLA-LA MANCHA
                    </h1>
                </div>
            </div>

            {/* Navegación principal */}
            <nav className={`nav ${scrolled ? "is-scrolled" : ""}`} ref={ref}>
                <ul className="nav__list">
                    <li className="nav-link">
                        <Link to="/resultados">Resultados</Link>
                    </li>
                    <li className="nav-link">
                        <Link to="/clasificaciones">Clasificaciones</Link>
                    </li>

                    {/* NUEVO: Competiciones */}
                    <li className={`nav-link has-sub ${open === "comp" ? "open" : ""}`}>
                        <button
                            className="nav-btn"
                            onClick={() => toggleSub("comp")}
                        >
                            Competiciones
                        </button>
                        <ul className="submenu">
                            <li className="sub">
                                <Link to="/comite-competicion">Comité de Competiciones</Link>
                            </li>
                            <li className="sub">
                                <Link to="/comite-apelacion">Comité de Apelaciones</Link>
                            </li>
                        </ul>
                    </li>

                    {/* NUEVO: Normativa */}
                    <li className={`nav-link has-sub ${open === "norm" ? "open" : ""}`}>
                        <button className="nav-btn" onClick={() => toggleSub("norm")}>
                            Normativas
                        </button>
                        <ul className="submenu">
                            <li className="sub">
                                <Link to="/reglamentos">Reglamentos</Link>
                            </li>
                            <li className="sub">
                                <Link to="/noreba">Noreba</Link>
                            </li>
                            <li className="sub">
                                <Link to="/circulares">Circulares</Link>
                            </li><li className="sub">
                                <Link to="/doc_interes">Documentos de interés</Link>
                            </li>
                        </ul>
                    </li>

                    {/* NUEVO: Seguro Deportivo */}
                    <li className={`nav-link has-sub ${open === "seguro" ? "open" : ""}`}>
                        <button className="nav-btn" onClick={() => toggleSub("seguro")}>
                            Seguro Deportivo
                        </button>
                        <ul className="submenu">
                            <li className="sub">
                                <Link to="/normas">Normas de Asistencia</Link>
                            </li>
                            <li className="sub">
                                <Link to="/centros">Centros Asistenciales</Link>
                            </li>
                            <li className="sub">
                                <Link to="/poliza">Póliza</Link>
                            </li>
                        </ul>
                    </li>

                    {/* NUEVO: Elecciones */}
                    <li className={`nav-link has-sub ${open === "elecciones" ? "open" : ""}`}>
                        <button className="nav-btn" onClick={() => toggleSub("elecciones")}>
                            Elecciones
                        </button>
                        <ul className="submenu">
                            <li className="sub">
                                <Link to="/convocatoria">Convocatoria</Link>
                            </li>
                            <li className="sub">
                                <Link to="/censo">Censo</Link>
                            </li>
                            <li className="sub">
                                <Link to="/modelo">Modelo</Link>
                            </li>
                            <li className="sub">
                                <Link to="/actas">Actas</Link>
                            </li>
                        </ul>
                    </li>

                    <li className="nav-link">
                        <Link to="/clubs">Clubes</Link>
                    </li>
                    <li className="nav-link">
                        <a href="https://cursos.fbmclm.es/">Aula Virtual</a>
                    </li>
                </ul>
            </nav>

            {/* Menú móvil */}
            <div className="menu-burguer">
                <div className="menu-icon" onClick={toggleMenu}>
                    <div className={`line ${menuOpen ? "open" : ""}`} />
                    <div className={`line ${menuOpen ? "open" : ""}`} />
                    <div className={`line ${menuOpen ? "open" : ""}`} />
                </div>
            </div>

            <nav className={`nav-mobile ${menuOpen ? "open" : ""}`}>
                <li className="nav-mobile-link">
                    <Link to="/resultados" onClick={closeMenu}>Resultados</Link>
                </li>
                <li className="nav-mobile-link">
                    <Link to="/clasificaciones" onClick={closeMenu}>Clasificaciones</Link>
                </li>

                {/* Competiciones */}
                <li className="nav-mobile-link has-sub">
                    <span className="nav-mobile-btn">Competiciones</span>
                    <ul className="submenu-mobile">
                        <li><Link to="/comite-competicion" onClick={closeMenu}>Comité de Competiciones</Link></li>
                        <li><Link to="/comite-apelacion" onClick={closeMenu}>Comité de Apelaciones</Link></li>
                    </ul>
                </li>

                {/* Normativa */}
                <li className="nav-mobile-link has-sub">
                    <span className="nav-mobile-btn">Normativas</span>
                    <ul className="submenu-mobile">
                        <li><Link to="/reglamentos" onClick={closeMenu}>Reglamentos</Link></li>
                        <li><Link to="/noreba" onClick={closeMenu}>Noreba</Link></li>
                        <li><Link to="/circulares" onClick={closeMenu}>Circulares</Link></li>
                        <li><Link to="/doc_interes" onClick={closeMenu}>Documentos de interés</Link></li>

                    </ul>
                </li>

                {/* Seguro Deportivo */}
                <li className="nav-mobile-link has-sub">
                    <span className="nav-mobile-btn">Seguro Deportivo</span>
                    <ul className="submenu-mobile">
                        <li><Link to="/normas" onClick={closeMenu}>Normas de Asistencia</Link></li>
                        <li><Link to="/centros" onClick={closeMenu}>Centros Asistenciales</Link></li>
                        <li><Link to="/poliza" onClick={closeMenu}>Póliza</Link></li>
                    </ul>
                </li>

                {/* Elecciones */}
                <li className="nav-mobile-link has-sub">
                    <span className="nav-mobile-btn">Elecciones</span>
                    <ul className="submenu-mobile">
                        <li><Link to="/convocatoria" onClick={closeMenu}>Convocatoria</Link></li>
                        <li><Link to="/censo" onClick={closeMenu}>Censo</Link></li>
                        <li><Link to="/modelo" onClick={closeMenu}>Modelo</Link></li>
                        <li><Link to="/actas" onClick={closeMenu}>Actas</Link></li>
                    </ul>
                </li>

                <li className="nav-mobile-link">
                    <Link to="/clubs" onClick={closeMenu}>Clubes</Link>
                </li>
                <li className="nav-mobile-link">
                    <a href="https://cursos.fbmclm.es/">Aula Virtual</a>
                </li>
            </nav>
        </header>
    );
}

export default Header;
